export default "__VITE_ASSET__fe499f72__"